import { Link } from 'react-router'
import { AppShell } from '../app/AppShell'
import { ArcaneCircle, Card } from '../design/components'
import styles from './Placeholder.module.css'

export interface PlaceholderProps {
  title: string
  subtitle?: string
  /** Which plan stage delivers this screen. */
  stage: string
  what: string
}

/**
 * A themed "not built yet" screen for the tabs whose stages have not landed.
 *
 * It exists so the shell is genuinely navigable at the end of Stage 2 rather than
 * routing to blank pages — and so the next stage has an obvious place to start.
 */
export function Placeholder({ title, subtitle, stage, what }: PlaceholderProps) {
  return (
    <AppShell title={title} {...(subtitle !== undefined && { subtitle })}>
      <div className={styles.wrap}>
        <ArcaneCircle size={280} className={styles.circle} />
        <Card label={stage} hint="Not built yet">
          <p className={styles.text}>{what}</p>
        </Card>
        {import.meta.env.DEV && (
          <p className={styles.devHint}>
            The component library is browsable at <Link to="/dev/gallery">/dev/gallery</Link>.
          </p>
        )}
      </div>
    </AppShell>
  )
}
